var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticStyle:{"color":"#fff","margin-left":"20px"}},[_vm._v("校服V2.0系统功能列表")]),_c('div',[_c('userInfo')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }